import { useState, useEffect } from "react";
import { Navbar, Container } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import { BrowserRouter as Router } from "react-router-dom";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
    setMenuOpen(false);
  };

  const navLinks = [
    { id: "home", label: "Home", href: "#home" },
    { id: "skills", label: "Skills", href: "#skills" },
    { id: "projects", label: "Projects", href: "#projects" },
    { id: "experience", label: "Experience", href: "#experience" },
  ];

  return (
    <Router>
      {/* Desktop / top navbar */}
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          {/* Custom hamburger — only visible on mobile */}
          <button
            className={`mobile-hamburger${menuOpen ? " open" : ""}`}
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span />
            <span />
            <span />
          </button>

          {/* Desktop links */}
          <div className="desktop-nav ms-auto d-none d-md-flex align-items-center">
            <nav className="navbar-nav flex-row">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.href}
                  className={`nav-link navbar-link${activeLink === link.id ? " active" : ""}`}
                  onClick={() => onUpdateActiveLink(link.id)}
                >
                  {link.label}
                </a>
              ))}
            </nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href="https://www.linkedin.com/in/yasiru-deshan-0b0593211/"><img src={navIcon1} alt="LinkedIn" /></a>
                <a href="https://www.facebook.com/yasiru.deshan.9/"><img src={navIcon2} alt="Facebook" /></a>
                <a href="https://www.instagram.com/__yassa__/"><img src={navIcon3} alt="Instagram" /></a>
              </div>
              <a href="mailto:yasirudeshan3@gmail.com?subject=Let's Work Together&body=Hi Yasiru,%0D%0A%0D%0AI saw your portfolio and I'm interested in working with you on a project. Let's connect!%0D%0A%0D%0AThanks,%0D%0A[Your Name]">
                <button className="vvd"><span>Let's Connect</span></button>
              </a>
            </span>
          </div>
        </Container>
      </Navbar>

      {/* ── Fullscreen mobile menu overlay ── */}
      <div className={`mobile-menu-overlay${menuOpen ? " open" : ""}`} aria-hidden={!menuOpen}>
        {/* Close button */}
        <button
          className="mobile-menu-close"
          aria-label="Close menu"
          onClick={() => setMenuOpen(false)}
        >
          ✕
        </button>

        {/* Nav links */}
        <nav className="mobile-menu-nav">
          {navLinks.map((link, i) => (
            <a
              key={link.id}
              href={link.href}
              className={`mobile-menu-link${activeLink === link.id ? " active" : ""}`}
              style={{ animationDelay: `${0.1 + i * 0.08}s` }}
              onClick={() => onUpdateActiveLink(link.id)}
            >
              <span className="mobile-link-number">0{i + 1}</span>
              {link.label}
            </a>
          ))}
        </nav>

        {/* Bottom social + CTA */}
        <div className="mobile-menu-footer">
          <div className="mobile-social-icons">
            <a href="https://www.linkedin.com/in/yasiru-deshan-0b0593211/" aria-label="LinkedIn"><img src={navIcon1} alt="LinkedIn" /></a>
            <a href="https://www.facebook.com/yasiru.deshan.9/" aria-label="Facebook"><img src={navIcon2} alt="Facebook" /></a>
            <a href="https://www.instagram.com/__yassa__/" aria-label="Instagram"><img src={navIcon3} alt="Instagram" /></a>
          </div>
          <a
            href="mailto:yasirudeshan3@gmail.com?subject=Let's Work Together"
            className="mobile-cta-btn"
            onClick={() => setMenuOpen(false)}
          >
            Let's Connect
          </a>
        </div>
      </div>
    </Router>
  );
};
